module.exports = __webpack_public_path__ + "img/f_3.2fefc689.png";